import { HttpContext } from "@angular/common/http";
import { ConfirmationService, MessageService } from "primeng/api";
import { Observable } from "rxjs";
import { LoggingService } from "../../_services/logging.service";

export abstract class CrudAdapter<T, R> {
  constructor(
    protected messageService: MessageService,
    protected confirmationService: ConfirmationService,
    protected loggingService: LoggingService
  ) {}

  abstract get(
    page?: number,
    size?: number,
    sort?: Array<string>,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/hal+json";
      context?: HttpContext;
    }
  ): Observable<T>;

  abstract saveSingle(
    entity: R,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/hal+json";
      context?: HttpContext;
    }
  ): Observable<R>;

  abstract deleteById(
    id: string,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/hal+json";
      context?: HttpContext;
    }
  ): Observable<object>;

  abstract extractEntries(entries: any): R[];

  defaultEntityDialog(rowEntry: any): void {
    this.loggingService.debug("CrudAdapter", "Default entity dialog for rowEntry: " + JSON.stringify(rowEntry));
    // Implement a default dialog or form for displaying/editing the entity
    this.messageService.add({
      severity: "warn",
      summary: "Warning",
      detail: "Default entity dialog not implemented.",
      life: 3000,
    });
  }

  edit(rowEntry: any): void {
    if (rowEntry) {
      this.loggingService.debug("CrudAdapter", "Edit rowEntry: " + JSON.stringify(rowEntry));
      this.defaultEntityDialog(rowEntry);
      // this.saveSingle(rowEntry).subscribe(
      //   (response) => {
      //     this.messageService.add({
      //       severity: "success",
      //       summary: "Successful",
      //       detail: "Submission edited",
      //       life: 3000,
      //     });
      //   },
      //   (error) => {
      //     this.messageService.add({
      //       severity: "danger",
      //       summary: "Failed",
      //       detail: "Failed to edit id: " + rowEntry?.id,
      //       life: 3000,
      //     });
      //   }
      // );
    }
  }

  delete(rowEntry: any): void {
    if (rowEntry) {
      this.loggingService.debug("CrudAdapter", "Delete rowEntry: " + JSON.stringify(rowEntry));
      this.confirmationService.confirm({
        message: "Are you sure you want to delete " + rowEntry.id + "?",
        // header: "Confirm",
        // icon: "pi pi-exclamation-triangle",
        accept: () => {
          this.deleteById(rowEntry.id).subscribe(
            (response) => {
              this.messageService.add({
                severity: "success",
                summary: "Successful",
                detail: "Deleted " + rowEntry.id,
                life: 3000,
              });
            },
            (error) => {
              this.messageService.add({
                severity: "danger",
                summary: "Failed",
                detail: "Failed to delete " + rowEntry.id,
                life: 3000,
              });
            }
          );
        },
      });
    }
  }

  onClick(rowEntry: any): void {}
}
